import { legacyPlugins } from "/home/runner/work/jw-app/jw-app/node_modules/@unhead/vue/dist/legacy.mjs";
export default {
  disableDefaults: true,
  plugins: legacyPlugins,
}